export default __webpack_public_path__ + "static/cp-szenarios-be2e5a07ba6547307bb4e5e2f21c8a30.mp4";